
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"preserveAspectRatio":"none","viewBox":"0 0 662 344","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M300 0v232h214V0h-4v228H304V0h-4zM662 120h-44v112h44v-4h-40V124h40v-4z","fill":"#30C07C"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 2v340h660v-4H6V2H2z","fill":"#484848"}}),_c('path',{attrs:{"fill":"#C6EED1","d":"M658 337.63h4V344h-4zM0 0h7v2.73H0zM0 335h9v9H0z"}})])
          )
        }
      }
    